<template>
  <el-dialog
    class="modal-batch-stores"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="content">
      <el-form
        ref="batchStores"
        :rules="rules"
        v-loading="isLoading"
        label-position="right"
        :model="formData"
        @submit.native.prevent
        class="batch-stores__form"
      >
        <el-form-item label="所属品牌:" prop="brandName">
          <el-input
            :disabled="true"
            v-model="formData.brandName"
            placeholder="必选, 单选"
            style="width: 291px;"
          ></el-input>
          <el-button @click="$_select" class="select__btn">选择</el-button>
        </el-form-item>

        <el-form-item label="接收结果邮箱:" prop="emails" type="textarea" style="margin-bottom: 0;">
          <el-input
            type="textarea"
            style="width: 366px; height: 100px;"
            resize="none"
            placeholder="必填"
            v-model="formData.emails"
          ></el-input>
          <div class="input-tips">*最多输入20个邮箱地址, 多个用", "隔开</div>
        </el-form-item>

        <el-form-item label>
          <span>请下载批量导入模板, 编辑后选择对应导入文件点击"上传"生成</span>
          <a href="/门店列表.xlsx" class="download__btn">下载导入模板</a>
        </el-form-item>

        <el-form-item label prop="filename">
          <label for="upload">
            <span
              v-show="formData.filename === ''"
              class="filename__span el-input__inner placeholder"
            >上传的文件, 仅支持*.xls或*.xlsx的文件类型</span>
            <span
              v-show="formData.filename !== ''"
              class="filename__span el-input__inner"
            >{{formData.filename}}</span>

            <input
              type="file"
              ref="fileInput"
              @change="$_selectFile"
              name="upload"
              id="upload"
              accept=".xls, .xlsx"
              style="display: none;"
            />
            <span class="select-btn__span">选择文件</span>
          </label>
          <el-button @click="$_upload" class="select__btn">上传</el-button>
          <div class="tips-txt">*如导入文件中存在已有门店ID, 系统自动更新对应的门店名称 <br> *省市区名称需按PaaS行政区域表规范导入<br>*门店营业时间日期：可为空，若有输入，则格式为星期/时间，如：星期一,星期二/00:12-10:00，星期多个时间用“,”区隔，多段时间请换行输入</div>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <!-- <el-button class="save__btn" @click="$_submit">保存</el-button> -->
      <el-button class="cancel__btn" @click="$_cancle">放弃</el-button>
    </div>

    <select-brand
      v-if="modal.show === true && modal.template === 'select-brand'"
      :title="modal.title"
      :selected="modal.data"
      @callback="$_callbackBrand"
      @close="$_close"
    ></select-brand>
  </el-dialog>
</template>
<script>
import XLSX from "xlsx";
import * as Utils from "@/plugins/utils";
import SelectBrand from "@/components/modal-select-brand";

export default {
  name: "modal-modify-store",
  props: {
    title: { type: String, default: "" }
  },
  inject: ["stores"],
  data() {
    return {
      visible: false,
      isLoading: false,
      formData: {
        brandId: 0,
        brandName: "", // 品牌名称
        emails: "",
        filename: "",
        importShopList: []
      },
      modal: {
        show: false,
        title: "",
        template: "",
        data: {}
      },
      rules: {
        brandName: [{ required: true, message: "请选择所属品牌" }],
        emails: [
          { required: true, message: "请输入邮箱地址" },
          {
            validator: (rule, value, callback) => {
              if (value) {
                if (value.match(/\w.*,{2,}/) || value.match(/^[,].*/)) {
                  callback(new Error(`请输入正确的邮箱地址, 格式:"名称@域名"`));
                } else {
                  let emails = value.split(",").filter(email => email != "");
                  if (emails.length > 20) {
                    callback(new Error(`最多可输入20个邮箱地址!`));
                  }
                  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                  let hasError = emails.some(item => {
                    return item.replace(/\s*/, "").match(reg) === null;
                  });

                  if (hasError) {
                    callback(
                      new Error(`请输入正确的邮箱地址, 格式:"名称@域名"`)
                    );
                  } else {
                    callback();
                  }
                }
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        filename: [{ required: true, message: "请上传需要导入的文件" }]
      }
    };
  },
  methods: {
    // 点击选择品牌按钮事件
    $_select() {
      // 处理已选择的品牌数据
      this.modal.data = {
        brandId: this.formData.brandId
      };
      this.modal.title = "选择品牌";
      this.modal.template = "select-brand";
      this.modal.show = true;
    },
    // 选择品牌回调
    $_callbackBrand(data) {
      let { brandId, brandName } = data;
      this.formData.brandId = brandId;
      this.formData.brandName = brandName;
      // this.$refs['batchStores'].validate();
    },
    // 关闭选择品牌
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.title = "";
      this.modal.data = {};
    },

    $_clearSelectedFile() {
      this.$refs["fileInput"].value = "";
      this.formData.filename = "";
      this.formData.importShopList.splice(0);
    },
    // 选择文件
    $_selectFile(event) {
      const self = this;
      const files = event.target.files;
      if (!files || files.length === 0) return false;
      const file = files[0];
      const filename = file.name;
      let fileType = filename.replace(/([^\.]+\.)+(\S+)/g, "$2");

      if (!~["xls", "xlsx"].indexOf(fileType)) {
        $MessageBox.alert({
          content: "文件格式错误!",
          onOk() {
            self.$_clearSelectedFile();
          }
        });
        return false;
      }
      let fileSize = file.size / 1024 / 1024;
      if (fileSize > 1) {
        $MessageBox.alert({
          content: "文件大小不能超过1MB!",
          onOk() {
            self.$_clearSelectedFile();
          }
        });
        return false;
      }
      const reader = new FileReader();
      reader.onload = e => {
        const bstr = e.target.result;
        try {
          XLSX.read(bstr, { type: "binary" });
        } catch (error) {
          $MessageBox.alert({
            content: "读取文件失败!",
            onOk() {
              self.$_clearSelectedFile();
            }
          });
          return false;
        }
        const wb = XLSX.read(bstr, { type: "binary" });

        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

        const header = data[0].concat([]);

        if (
          header.length !== 10 ||
          header[0] !== "门店名称（必填）" ||
          header[1] !== "门店ID（必填）"||
          header[2] !== "省份名称" ||
          header[3] !== "城市名称"||
          header[4] !== "行政区域名称" ||
          header[5] !== "经度"||
          header[6] !== "纬度" ||
          header[7] !== "门店电话"||
          header[8] !== "门店地址" || 
          header[9] !== "门店IM系统"
        ) {
          $MessageBox.alert({
            content: "上传文件表头不符合模板要求，请重修后重新上传!",
            onOk() {
              self.$_clearSelectedFile();
            }
          });
          return false;
        }
        this.formData.filename = filename;
        // this.$refs['batchStores'].validate();
        data.shift();

        this.formData.importShopList = data
          .map(item => {
            if (typeof item[0] === "undefined") {
              item[0] = "";
            }
            if (typeof item[1] === "undefined") {
              item[1] = "";
            }
            if (typeof item[2] === "undefined") {
              item[2] = "";
            }
            if (typeof item[3] === "undefined") {
              item[3] = "";
            }
            if (typeof item[4] === "undefined") {
              item[4] = "";
            }
            if (typeof item[5] === "undefined") {
              item[5] = "";
            }
            if (typeof item[6] === "undefined") {
              item[6] = "";
            }
            if (typeof item[7] === "undefined") {
              item[7] = "";
            }
            if (typeof item[8] === "undefined") {
              item[8] = "";
            }
            if (typeof item[9] === "undefined") {
              item[9] = "";
            }
            return {
              storeId: item[1],
              storeName: item[0],
              provinceName: item[2],
              cityName: item[3],
              areaName: item[4],
              longitude: item[5] + "",
              latitude: item[6] + "",
              telePhone: item[7] + "",
              address: item[8],
              imSystem: item[9]
            };
          })
          .filter(item => !(item.storeId === "" && item.storeName === "" && item.provinceName === "" && item.cityName === "" && item.areaName === "" && item.longitude === "" && item.telePhone === "" && item.address === "" && item.latitude === "" && item.imSystem === ""));
      };
      reader.readAsBinaryString(file);
    },
    // 点击上传按钮
    $_upload() {
      this.$refs["batchStores"].validate(valid => {
        if (valid) {
          const self = this;
          const arr = this.formData.importShopList.filter(item => item.telePhone).map(item => item.telePhone)
          let reg =
                  /^(1[3-9]\d{9}|([\(（]?0[0-9]{2,3}[）\)]?[-]?)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?)$/;
          let hasError = arr.some(item => {
                    return item.replace(/\s*/, "").match(reg) === null;
                  });
          if (hasError) {
            $MessageBox.alert({
              content: '存在电话号码错误的数据，请重新导入！'
            });
            return false;
          }

          if (
            this.formData.filename !== "" &&
            this.formData.importShopList.length > 0
          ) {
            let { brandId, emails, importShopList } = this.formData;
            let emailsArr = emails.split(",");
            this.isLoading = true;
            this.$service
              .post("imoprtStores", {
                brandId,
                emails: emailsArr,
                importShopList
              })
              .then(result => {
                if (result.$.checkResult(result, true)) {
                  $MessageBox.alert({
                    content: result.msg,
                    onOk() {
                      self.$emit("callback");
                    }
                  });
                }
                this.isLoading = false;
              });
          } else {
            $MessageBox.alert({ content: "请上传需要导入的文件!" });
          }
        }
      });
    },

    $_submit() {
      this.$refs["batchStores"].validate(valid => {
        if (valid) {
          const self = this;
          self.isLoading = true;
        }
      });
    },
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    }
  },
  created() {},
  mounted() {
    this.visible = true;
  },
  components: {
    SelectBrand
  }
};
</script>

<style lang="scss" scoped>
.batch-stores__form {
  padding: {
    left: 20px;
  }
}
.content {
  padding: 20px 20px;
  color: #535353;
  .title {
    height: 32px;
    color: #384e8c;
    font-size: 14px;
    font-weight: 700;
  }
}
.filename__span {
  position: relative;
  font-size: 12px;
  width: 291px;
  vertical-align: middle;
  &.placeholder {
    color: #aaa;
  }
}
.select__btn,
.select-btn__span {
  margin-left: 8px;
}
.select-btn__span {
  display: inline-block;
  border-radius: 2px;
  background-color: #1895dd;
  min-width: 64px;
  height: 26px;
  text-align: center;
  line-height: 26px;
  white-space: nowrap;
  cursor: pointer;
  color: #fff;
}
.tips-txt {
  color: #ea2a2a;
  margin: {
    top: 8px;
  }
}
/deep/ .download__btn{
  display: inline-block;
  border-radius: 2px;
  background-color: #1895dd;
  min-width: 64px;
  height: 26px;
  text-align: center;
  line-height: 26px;
  white-space: nowrap;
  cursor: pointer;
  color: #fff;
  padding: 0px 6px;
  margin-left: 8px;
}
</style>


